import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { EditIconButton } from 'components';
import { customerApplicationContext } from 'helpers/services';
import { LocalizationIds } from 'helpers/Localizations';
import { localeManagerContext } from 'helpers/Locale';
import { customerTicketDetailsContext } from '../../CustomerTicketDetailsContext';
import EditTicket from './EditTicket';


let BaseInfo = () => {
    let { formatMessage } = useIntl();

    let { ticketStatuses, ticketPriorities, getSubCategoryById } = useContext(customerApplicationContext);
    let { currentLocale } = useContext(localeManagerContext);

    let service = useContext(customerTicketDetailsContext);


    return (
        <div style={{ backgroundColor: '#efefef' }}>
            <Grid container>
                <Grid item xs>
                    <Typography variant="subtitle2" style={{ color: 'rgb(183, 0, 5)' }}>
                        <b>{formatMessage({ id: LocalizationIds.Details }).toUpperCase()}</b>
                    </Typography>
                </Grid>
                {service.ticket.isReadOnly === false &&
                    <Grid item>
                        <EditIconButton onClick={() => service.openEditDialogHandler()} />
                    </Grid>
                }
            </Grid>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        <b>{formatMessage({ id: LocalizationIds.Status })}</b>
                    </Typography>
                    <Typography variant="body1">{ticketStatuses.find(f => f.code === service.ticket.status)?.descriptions[currentLocale] || service.ticket.status}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        <b>{formatMessage({ id: LocalizationIds.Category })}</b>
                    </Typography>
                    {getSubCategoryById(service.ticket.ticketSubCategoryId) &&
                        <Typography variant="body1">
                            {getSubCategoryById(service.ticket.ticketSubCategoryId)?.categoryNames[currentLocale]} /&nbsp;
                            {getSubCategoryById(service.ticket.ticketSubCategoryId)?.names[currentLocale]}
                        </Typography>
                    }
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        <b>{formatMessage({ id: LocalizationIds.Priority })}</b>
                    </Typography>
                    <Typography variant="body1">{ticketPriorities.getValueByKey(service.ticket.priority) || service.ticket.priority}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2"><b>{formatMessage({ id: LocalizationIds.Reporter })}</b></Typography>
                    <Typography variant="body1">{service.ticket.reporterUser || formatMessage({ id: LocalizationIds.NoOne })}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2">
                        <b>{formatMessage({ id: LocalizationIds.AssignedTo })}</b>
                    </Typography>
                    <Typography variant="body1">{service.ticket.assigneeUser || formatMessage({ id: LocalizationIds.NoOne })}</Typography>
                </Grid>
            </Grid>

            {service.showEditDialog === true &&
                <EditTicket
                    onClose={(reloadTicket: boolean) => service.closeEditDialogHandler(reloadTicket)}
                    partialTicket={{
                        ticketId: service.ticket.ticketId,
                        title: service.ticket.title
                    }}
                />
            }
        </div>
    )
}

export default BaseInfo;